module.exports = __webpack_public_path__ + "static/media/TxPuja.411877db.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/TxPuja.svg
// module id = 218
// module chunks = 0